import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import times from 'lodash/times'
import PaginationDot from './Dot'

export type PaginationProps = {
    currentPage: number
    totalPages: number
    activeDotColor: 'onyx' | 'pearl'
}

const Pagination: FunctionComponent<PaginationProps> = ({
    currentPage,
    totalPages,
    activeDotColor,
}) => {
    const maxIndex = totalPages - 1
    return (
        <Grid horizontal noExpand>
            {times(
                totalPages,
                (index: number): ReactElement => (
                    <PaginationDot
                        key={`pag-dot_${maxIndex}_${index}`}
                        color={index === currentPage - 1 ? activeDotColor : 'keshi-3'}
                        spacingRight={index < maxIndex}
                    />
                )
            )}
        </Grid>
    )
}

export default Pagination
